import { Select } from "antd";
import type { FC } from "react";
import type { Project } from "../../../types";
import { useSelectedProjectIds } from "./use-selected-project-ids";

interface ProjectSelectProps {
  projects: Project[];
}

export const ProjectSelect: FC<ProjectSelectProps> = ({ projects }) => {
  const [selectedProjectIds, setSelectedProjectIds] = useSelectedProjectIds();

  return (
    <Select
      mode="multiple"
      allowClear
      style={{ minWidth: 260 }}
      placeholder="Filter by project"
      value={selectedProjectIds}
      onChange={setSelectedProjectIds}
      options={projects.map((project) => ({ label: project.name, value: project.id }))}
    />
  );
};
